// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { ScatterPlotNodeData } from '@nivo/scatterplot';
import { type FC } from 'react';

interface RiskVsReturnsGraphTooltipProps {
  node: ScatterPlotNodeData<any>;
}

export const RiskVsReturnsGraphTooltip: FC<RiskVsReturnsGraphTooltipProps> = ({
  node,
}) => {
  return (
    <div className="rounded-lg bg-white p-2 text-secondary-dark shadow-lg">
      <h5 className="text-center text-lg font-medium uppercase">{node.serieId}</h5>
      <dl className="flex flex-col">
        <div className="flex justify-between space-x-2">
          <dt>Volatility:</dt>
          <dd>{node.formattedX}%</dd>
        </div>
        <div className="flex justify-between space-x-2">
          <dt>Return:</dt>
          <dd>{node.formattedY}%</dd>
        </div>
      </dl>
    </div>
  );
};
